import { PARTNER_PRESETS, PartnerPreset } from "./registry";

/*
* Detects which partner settings to apply, based on the URL.
* Is used before login.
*/

export function detectPartnerFromHost( host: string = window.location.host): PartnerPreset {

  if (host.includes("happy")) {
    return PARTNER_PRESETS.happyads;
  } else {
    return PARTNER_PRESETS.viaads;
  }
}
